module.exports = __webpack_public_path__ + "static/img/evaluation_data_icon@3x.1a8bc95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/evaluation_data_icon@3x.png
// module id = 77Cf
// module chunks = 1